<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <ProductPlanComponent v-if="selectedIndex === 0" ref="refProductPlanComponent"/>
  </div>
</template>

<script>
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import ProductPlanComponent from './regCarOptionComponent'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '차종별 사양 현황'
        }
      ],
      selectedVendor: null

    }
  },
  components: {
    DxTabPanel,
    ProductPlanComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
  }
}
</script>

<style lang="scss">
.item-row-body {
  tr{
    height: 26px;
    border-bottom: 1px solid rgb(224,224,224);
    td{
      border-right: 1px solid rgb(224,224,224);
      padding: 0 2px 0 2px;
    }
  }
  .row-number-span {
    text-align: right;
  }
  .row-text-span {
    white-space:nowrap;
    text-overflow:ellipsis;
    overflow:hidden;
  }
  .grand-total-row {
    background-color: rgb(184, 226, 255);
    td{
      color: rgb(136, 0, 0);
    }
  }
  .sub-total-row {
    background-color: rgb(217, 252, 255);
    td{
      color: rgb(0, 0, 168);
    }
  }
}
.item-row-body:hover{
  background-color: rgb(226, 226, 226);
}
</style>
